module.exports = __webpack_public_path__ + "va.512026fa7fe99785b479.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/va.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/va.svg
// module chunks = styles